import { createSlice } from "@reduxjs/toolkit";
import { ICommunityStatisticsState } from "./types";
import { fetchCommunityStatistics, fetchCommunityTransactionAggregates, fetchLatestTransactions, fetchLatestUsers, fetchRegistrationStatistics } from "./community-statistics-thunk";
import { ErrorType } from "@/shared/types";

const initialState: ICommunityStatisticsState = {
    /* community statistics */
    communityStatistics: {
        totalEmployees: 0,
        totalSocialUsers: 0,
        countEmployeesTransactions: 0,
        countSocialProgramTransactions: 0,
        totalEmployeesTransactions: 0,
        totalSocialProgramTransactions: 0
    },
    isCommunityStatistisLoading: false,
    communityStatisticsError: null,
    isCommunityStatisticsFirstLoad: true,
    /* community transaction statistics */
    communityTransactionStatistics: {
        bonuses: {},
        items: [],
        count: 0,
        sum_amount_nano: 0
    },
    isCommunityTransactionStatistisLoading: false,
    communityTransactionStatisticsError: null,
    isCommunityTransactionStatisticsFirstLoad: true,
    /* registration statistics */
    registrationStatistics: {},
    isRegistrationStatisticsLoading: false,
    registrationStatisticsError: null,
    isRegistrationStatisticsFirstLoad: true,
    /* latest users  */
    totalUsersCount: 0,
    latestUsers: [],
    isLatestUsersLoading: false,
    isLatestUsersFirstLoad: true,
    latestUsersError: null,
    /* latest transactions */
    latestTransactions: [],
    isLatestTransactionsLoading: false,
    isLatestTransactionsFirstLoad: true,
    latestTransactionsError: null
}

const communityStatisticsSlice = createSlice({
    name: 'communityStatistics',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
        .addCase(fetchCommunityStatistics.pending, (state) => {
            state.isCommunityStatistisLoading = true
            state.communityStatisticsError = null
        })
        .addCase(fetchCommunityStatistics.fulfilled, (state, action) => {
            state.isCommunityStatisticsFirstLoad = false
            state.communityStatistics = action.payload
            state.isCommunityStatistisLoading = false
            state.communityStatisticsError = null
        })
        .addCase(fetchCommunityStatistics.rejected, (state, action) => {
            state.isCommunityStatistisLoading = false
            state.communityStatisticsError = action.payload as ErrorType ?? null
        })
        .addCase(fetchCommunityTransactionAggregates.pending, (state) => {
            state.isCommunityTransactionStatistisLoading = true
            state.communityTransactionStatisticsError = null
        })
        .addCase(fetchCommunityTransactionAggregates.fulfilled, (state, action) => {
            state.isCommunityTransactionStatistisLoading = false
            state.communityTransactionStatistics = action.payload
            state.isCommunityTransactionStatisticsFirstLoad = false
            state.communityTransactionStatisticsError = null
        })
        .addCase(fetchCommunityTransactionAggregates.rejected, (state, action) => {
            state.isCommunityTransactionStatistisLoading = false
            state.communityTransactionStatisticsError = action.payload as ErrorType ?? null
        })
        .addCase(fetchLatestUsers.pending, (state) => {
            state.isLatestTransactionsLoading = true
            state.latestTransactionsError = null
        })
        .addCase(fetchLatestUsers.fulfilled, (state, action) => {
            state.isLatestUsersLoading = false
            state.latestUsers = action.payload.items
            state.totalUsersCount = action.payload.totalCount
            state.isLatestTransactionsFirstLoad = false
            state.latestUsersError = null
        })
        .addCase(fetchLatestUsers.rejected, (state, action) => {
            state.isLatestUsersLoading = false
            state.latestUsersError = action.payload as ErrorType ?? null
        })
        .addCase(fetchRegistrationStatistics.pending, (state) => {
            state.isRegistrationStatisticsLoading = true
            state.registrationStatisticsError = null
        })
        .addCase(fetchRegistrationStatistics.fulfilled, (state, action) => {
            state.isRegistrationStatisticsFirstLoad = false
            state.registrationStatistics = action.payload
            state.isRegistrationStatisticsLoading = false
            state.registrationStatisticsError = null
        })
        .addCase(fetchRegistrationStatistics.rejected, (state, action) => {
            state.isRegistrationStatisticsLoading = false
            state.registrationStatisticsError = action.payload as ErrorType ?? null
        })
        .addCase(fetchLatestTransactions.pending, (state) => {
            state.isLatestTransactionsLoading = true
            state.latestTransactionsError = null
        })
        .addCase(fetchLatestTransactions.fulfilled, (state, action) => {
            state.isLatestTransactionsFirstLoad = false
            state.latestTransactions = action.payload
            state.isLatestTransactionsLoading = false
            state.latestTransactionsError = null
        })
        .addCase(fetchLatestTransactions.rejected, (state, action) => {
            state.isLatestTransactionsLoading = false
            state.latestTransactionsError = action.payload as ErrorType ?? null
        })
    },
})

export default communityStatisticsSlice.reducer 